import React, { useEffect, useState } from 'react'

// react redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BsEyeSlash, BsEye } from "react-icons/bs";

// formik
import { useFormik } from "formik";

// yup
import * as Yup from "yup";

// react toastify
import { toast } from "react-toastify";

// styles
import { PageContainer } from "../styles/ResetPasswordStyles"

// API
import { resetPassword } from 'utlis/Apis/Customers_API';

function ResetPassword(props) {

    // props
    const {
        commonToken,

        userIdFromUrl,
        userTokenFromUrl,
    } = props

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    // initial form values
    const initialFormValues = {
        password: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        password: Yup.string()
            .required('This field is required')
            .min(8, "The password must be at least 8 characters long")
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Pasword must contain at least one uppercase letter, one lowercase letter, one number and one special character")
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {

            // btn loading
            setBtnDisabled(true)
            setBtnLoading(true)

            const requiredData = {
                password: values.password,
                userId: userIdFromUrl,
                userToken: userTokenFromUrl,
            }

            // validating user details
            resetPassword(commonToken ?? "", requiredData).then(res => {
                // btn loading
                setBtnLoading(false)

                const resData = res.data

                if (resData?.success) {
                    formik.resetForm() // resetting the form

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success("Password updated successfully", {
                        autoClose: 2500,
                        onClose: () => { },
                    });
                }

                if (resData?.error) {
                    console.log("resData error ", resData);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.info(resData?.message ?? "Unknown error", {
                        autoClose: 2500,
                        onClose: () => {
                            // btn loading
                            setBtnDisabled(false)
                        },
                    });
                }

            }).catch(err => {
                console.log("errr ", err);

                // btn loading
                setBtnDisabled(true)
                setBtnLoading(true)
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // toggle password
    const togglePasswordDisplay = ev => {
        ev.preventDefault()
        setShowPassword(!showPassword)
    }

    // verifying email
    useEffect(() => {

    }, [])

    return (
        <PageContainer>
            <div className="container">
                <div className="reset-password-inner">
                    <div className="header-sec mb-3">
                        <p className="head st-fw-800 st-fs-20 mb-1">Reset your password</p>
                        <p className="desc mb-0">Enter your new password.</p>

                    </div>

                    {/* form */}
                    <div className="form">
                        <form
                            onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            <div className={`form-item position-relative mb-3 ${(formik.touched.password && formik.errors.password) ? "has-error" : ""}`}>
                                <label className="mb-2 st-fw-800">New Password <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control rounded-0"
                                    {...formik.getFieldProps('password')}
                                />

                                <div className="icon position-absolute">
                                    <div className="cursor-pointer" onClick={togglePasswordDisplay}>
                                        {
                                            showPassword ? <BsEyeSlash /> : <BsEye />
                                        }
                                    </div>
                                </div>

                                {
                                    (formik.touched.password && formik.errors.password) ? (
                                        <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                            {formik.errors.password}
                                        </div>
                                    ) : null
                                }
                            </div>

                            <div className="btns pt-2">
                                <button
                                    type="submit"
                                    className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
                                    disabled={btnDisabled}>
                                    {
                                        btnLoading ? (
                                            <Spinner animation="border" size="sm" />
                                        ) : (
                                            <span>Reset Password</span>
                                        )
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </PageContainer>
    )
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         func: bool => dispatch(func(bool)),
//     };
// };

export default connect(getDataFromStore, null)(ResetPassword);